import IcEdit from '@assets/details-camera-icons/IcEdit';
import usePopUp from '@hooks/usePopUp';
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import useMileSightSolar from '@pages/cameras/hook/useMilesightSolar';
import NoDataCameras from '@pages/cameras/list/components/NoDataCameras';
import color from '@theme/Colors';
import { useEffect, useState } from 'react';
import { formatISODate, formatUKTime } from 'src/helpers';

export default function DateAndTimeMilesightCameraSolar() {
    const popUpSetSystemTime = usePopUp();
    const { systemTimeMilesight, checkTimeInfo } = useMileSightSolar();

    const [time, setTime] = useState(formatUKTime(new Date()));

    useEffect(() => {
        setInterval(() => {
            setTime(formatUKTime(new Date()));
        }, 1000);
    }, []);

    return (
        <Stack width="100%" direction={{ md: 'column' }} gap={{ xs: 3, md: 0 }} spacing={2}>
            <Stack id="set-system-time" border={'1px solid #E4E7EC'} borderRadius={2} flex={1}>
                <Stack paddingX={2} paddingY={1} direction="row" justifyContent={'space-between'}>
                    <Typography fontSize={16}>Set the system time</Typography>
                    {systemTimeMilesight?.DevMac && (
                        <Tooltip
                            title={
                                <Typography align="center" fontWeight={450} fontSize={13} color={color.grey100}>
                                    The system will automatically correct the camera time
                                </Typography>
                            }
                            placement="top"
                            arrow
                        >
                            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
                                <IconButton
                                    disabled
                                    sx={{
                                        borderRadius: '3px',
                                        width: '24px',
                                        height: '24px',
                                        color: 'white',
                                        backgroundColor: '#2E7D32',
                                        ':hover': {
                                            backgroundColor: '#256428',
                                        },
                                        padding: '4px',
                                        '&.MuiIconButton-root.Mui-disabled': {
                                            backgroundColor: '#eee',
                                        },
                                    }}
                                    onClick={() => {
                                        popUpSetSystemTime.setTrue();
                                    }}
                                >
                                    <IcEdit style={{ width: '14px', height: '14px' }} />
                                </IconButton>
                            </Stack>
                        </Tooltip>
                    )}
                </Stack>

                <Divider
                    orientation="vertical"
                    sx={{
                        borderBottomWidth: 1,
                        borderColor: color.grey300,
                        mx: 2,
                    }}
                />

                {systemTimeMilesight ? (
                    <Stack paddingY={1} paddingX={2} spacing={2}>
                        <Grid xs={12} container>
                            <Grid xs={5}>
                                <Typography>Time zone:</Typography>
                            </Grid>
                            <Grid xs={7}>
                                {/* <Typography color={color.secondary}>{systemTimeMilesight.Timezone}</Typography> */}
                                <Typography color={color.secondary}>(UTC+00:00) United Kingdom(London)</Typography>
                            </Grid>
                        </Grid>
                        <Grid xs={12} container>
                            <Grid xs={5}>
                                <Typography>Daylight saving time:</Typography>
                            </Grid>
                            <Grid xs={7}>
                                <Typography>{checkTimeInfo().daylightSaving}</Typography>
                            </Grid>
                        </Grid>
                        <Grid xs={12} container>
                            <Grid xs={5}>
                                <Typography>Synchronize:</Typography>
                            </Grid>
                            <Grid xs={7}>
                                <Typography>{checkTimeInfo().syncMode}</Typography>
                            </Grid>
                        </Grid>
                        <Grid xs={12} container>
                            <Grid xs={5}>
                                <Typography>Time:</Typography>
                            </Grid>
                            <Grid xs={7}>
                                <Typography>{systemTimeMilesight.TimeManual}</Typography>
                            </Grid>
                        </Grid>
                    </Stack>
                ) : (
                    <NoDataCameras sx={{ border: 'none', minHeight: 150 }} />
                )}
            </Stack>

            <Stack id="current-system-time" border={'1px solid #E4E7EC'} borderRadius={2} flex={1}>
                <Box paddingX={2} paddingY={1}>
                    <Typography fontSize={16}>Current system time</Typography>
                </Box>

                <Divider
                    orientation="vertical"
                    sx={{
                        borderBottomWidth: 1,
                        borderColor: color.grey300,
                        mx: 2,
                    }}
                />

                <Stack paddingY={1} paddingX={2} spacing={2}>
                    <Grid xs={12} container>
                        <Grid xs={5}>
                            <Typography>Date:</Typography>
                        </Grid>
                        <Grid xs={7}>
                            <Typography>{formatISODate(new Date())}</Typography>
                        </Grid>
                    </Grid>
                    <Grid xs={12} container>
                        <Grid xs={5}>
                            <Typography>Time:</Typography>
                        </Grid>
                        <Grid xs={7}>
                            <Typography>{time}</Typography>
                        </Grid>
                    </Grid>
                </Stack>
            </Stack>

            {/* <PopUpSetSystemTime
                onSave={(data) => updateTimeInfo(data)}
                systemTime={systemTimeMilesight!}
                {...popUpSetSystemTime}
            /> */}
        </Stack>
    );
}
